new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#footer',
    data: {

    }
})

$(document).ready(function () {
    const footerSection = document.querySelectorAll('#footer .footer-section');
    if (footerSection.length) {
        footerSection.forEach((item) => {
            let footerContent = item.querySelector('.footer-section-content');
            item.addEventListener('click', () => {
                item.classList.toggle('active');
                footerContent.classList.toggle('active');
            })
        });
    }

    // selo do Reclame Aqui: um só por página (o script procura o id), então no mobile ele vai para o bloco Plataforma
    const raSeal = document.getElementById('ra-verified-seal');
    const plataformRecicle = document.querySelector('#footer .plataform .recicle');
    if (raSeal && plataformRecicle && window.matchMedia('(max-width: 991px)').matches) {
        plataformRecicle.appendChild(raSeal);
    }
});